import { AppContext } from "approot/global/services/context"

declare var angular: ng.IAngularStatic;
declare var globalContext: any;
declare var VERSION_FRONTEND: string;

window["globalContext"] = window;

class LoaderService {
	hide() {
		angular.element(".auth-loader").hide();
	}
}

export class LoginInitializer {
	static angularContext: any;
	static appContext: AppContext;

	private loader: LoaderService;

	/*@ngInject*/
	constructor(private $http, private $q: ng.IQService) {
		this.initServices();
		globalContext = window;
	}

	private initServices() {
		this.loader = new LoaderService();
	}

	init(angularContext): Promise<void> {
		globalContext = window;

		LoginInitializer.angularContext = angularContext;
		
		return this.$http.get("/webapi/auth/context")
			.then((response) => {
				var appContext = <AppContext>response.data;
				appContext.version_frontend = VERSION_FRONTEND;

				LoginInitializer.appContext = appContext;
				globalContext.appContext = LoginInitializer.appContext;

				this.loader.hide();
			});
	}
}